import styled from 'styled-components'

import { Link } from 'react-router-dom'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  position: relative;
`

export const HeaderContent = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 62px;

  display: flex;
  align-items: center;
`

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;

  color: ${theme.colors.white};
`

export const HeaderText = styled.span`
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
`

export const HeaderSubText = styled(Link)`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};
  text-decoration: none;

  display: flex;
  align-items: center;
  gap: 8px;
`

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;

  margin-right: 16px;

  object-fit: cover;
`

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  margin-left: auto;
`

export const IconWrapper = styled(Link)`
  position: relative;

  flex-grow: 0;

  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${theme.colors.white};
    }
  }
`

export const IconTag = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  width: 11px;
  height: 11px;

  border-radius: 50%;

  background-color: ${theme.colors.erro};
`
